import React from 'react';
import { useSelector } from 'react-redux';
import { Box, Typography, Alert, Card, CardContent } from '@mui/material';

function DataTestComponent() {
  // Test Redux data access
  const students = useSelector((state) => state.students) || [];
  const teachers = useSelector((state) => state.teachers) || [];
  const expenses = useSelector((state) => state.expenses) || [];
  const sales = useSelector((state) => state.sales) || [];
  const assets = useSelector((state) => state.assets) || [];
  const class_ = useSelector((state) => state.class) || [];
  const schooldetails = useSelector((state) => state.schooldetails) || [];

  console.log('DataTestComponent - Redux State:', {
    students: students.length,
    teachers: teachers.length,
    expenses: expenses.length,
    sales: sales.length,
    assets: assets.length,
    class: class_.length,
    schooldetails: schooldetails.length,
    sampleStudent: students[0],
    sampleTeacher: teachers[0],
    sampleExpense: expenses[0],
    sampleSale: sales[0],
    sampleAsset: assets[0],
    sampleClass: class_[0],
    sampleSchool: schooldetails[0]
  });

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        Data Test Component
      </Typography>
      
      <Card sx={{ mb: 2 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Redux Data Status
          </Typography>
          <Typography variant="body2">
            Students: {students.length} | 
            Teachers: {teachers.length} | 
            Expenses: {expenses.length} | 
            Sales: {sales.length} | 
            Assets: {assets.length} | 
            Classes: {class_.length} | 
            School Details: {schooldetails.length}
          </Typography>
        </CardContent>
      </Card>

      {students.length === 0 && (
        <Alert severity="warning">
          No student data found. This might be why the accounting data is not showing.
        </Alert>
      )}

      {students.length > 0 && (
        <Alert severity="success">
          Student data found! Sample student: {students[0]?.lastname} {students[0]?.othernames}
        </Alert>
      )}

      {schooldetails.length > 0 && (
        <Card sx={{ mt: 2 }}>
          <CardContent>
            <Typography variant="h6" gutterBottom>
              School Details
            </Typography>
            <Typography variant="body2">
              School Name: {schooldetails[0]?.schoolname}
            </Typography>
            <Typography variant="body2">
              School ID: {schooldetails[0]?._id}
            </Typography>
          </CardContent>
        </Card>
      )}
    </Box>
  );
}

export default DataTestComponent;
